import { render, staticRenderFns } from "./TemplateDuplicateModal.vue?vue&type=template&id=cb734b64&"
import script from "./TemplateDuplicateModal.vue?vue&type=script&lang=ts&"
export * from "./TemplateDuplicateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports